import debounce from 'debounce';
import { useEffect, useRef, useState } from 'react';

import { useTranslations } from '~i18n/hooks';
import { isSafeApp } from '~shared/utils/host';

import { useGridFilters } from '../../hooks/useGridFilters';
import { GridFiltersQueryParams as fields } from '../../model/names';
import { StyledSearchInput } from './styles';

type Props = {
	className?: string;
};

export const SearchButton = ({ className }: Props) => {
	const t = useTranslations('GridFilters');
	const { filters, updateFilters } = useGridFilters();
	const [value, setValue] = useState(filters.keyword ?? '');
	const initialValueSet = useRef(!!value);
	const debouncedUpdateFilters = debounce(updateFilters, 400);

	useEffect(() => {
		if (!initialValueSet.current && filters.keyword) {
			initialValueSet.current = true;
			setValue(filters.keyword);
		}
	}, [filters.keyword]);

	return (
		<StyledSearchInput
			className={className}
			shrinkable={!isSafeApp}
			placeholder={
				isSafeApp
					? t('filtersInputSafePlaceholder')
					: t('filtersInputNSFWPlaceholder')
			}
			maxLength={50}
			value={value}
			onChange={(e) => {
				setValue(e.target.value);
				initialValueSet.current = true;
				debouncedUpdateFilters({ [fields.keyword]: e.target.value });
			}}
			onReset={() => {
				setValue('');
				updateFilters({ [fields.keyword]: '' });
			}}
		/>
	);
};
